module.exports = __webpack_public_path__ + "static/media/Doghouse_1.02e11b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/doghouse/Doghouse_1.png
// module id = 1271
// module chunks = 3